import { useAgentProfile } from "@src/appV2/Agents/api/useAgentProfile";
import { CbhFeatureFlag, useCbhFlags } from "@src/appV2/FeatureFlags";
import { intersection } from "lodash";

export enum WorkerAvailabilityVersion {
  LOADING = "LOADING",
  V1 = "V1",
  V2 = "V2",
  DISABLED = "DISABLED",
}

export function useWorkerAvailabilityVersion(): WorkerAvailabilityVersion {
  const ldFlags = useCbhFlags();
  const { data: agentProfile, isLoading } = useAgentProfile();

  if (isLoading) {
    return WorkerAvailabilityVersion.LOADING;
  }

  const agentAvailableQualifications =
    agentProfile?.licensesData?.map((item) => item.qualification) ?? [];

  const { qualificationsV2 = [], qualifications = [] } =
    ldFlags[CbhFeatureFlag.ENABLE_WORKER_AVAILABILITY] ?? {};

  if (intersection(qualificationsV2, agentAvailableQualifications).length > 0) {
    return WorkerAvailabilityVersion.V2;
  }

  if (intersection(qualifications, agentAvailableQualifications).length > 0) {
    return WorkerAvailabilityVersion.V1;
  }

  return WorkerAvailabilityVersion.DISABLED;
}
